import { Component } from '@angular/core';

@Component({
  selector: 'app-authorization-failed',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent  { }
